module.exports = __webpack_public_path__ + "img/tmdb.272051a2.gif";